import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import App from '@/App';
import { queryClient } from '@/lib/query';
import { initTelegram } from '@/lib/telegram';
import { initUi } from '@/store/ui';
import { applyTheme, getTheme } from '@/theme';

import './index.css';
// Дополнение к перенесённому дизайну: переключатель проектов, нижняя
// навигация на мобиле, безопасные зоны Mini App. Импортируется ПОСЛЕ
// index.css — порядок каскада здесь значим.
import './lib/app-shell.css';

/*
 * Тема применяется до первого кадра.
 *
 * Если сделать это в эффекте, панель успевает мигнуть светлой темой на тёмной
 * машине — заметно и неприятно ровно один раз за загрузку, но каждую загрузку.
 */
applyTheme(getTheme());

// Mini App поднимаем до React: ready()/expand() и тема Telegram должны
// отработать раньше, чем отрисуется первый экран. В обычном браузере вызов
// ничего не делает.
initTelegram();

initUi();

const container = document.getElementById('root');
if (!container) throw new Error('#root не найден: проверьте index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* basename не задаём: панель раздаётся с корня, а Mini App открывается
          по прямой ссылке — лишний префикс сломал бы и то, и другое. */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
